export const thirdwebClientId = String(process.env.NEXT_PUBLIC_THIRDWEB_CLIENT_ID)
export const walletConnectProjectId = process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID
  ? process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID
  : undefined
